import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AnimatedDirective } from '../directives/animated.directive';
import { CapitalizePipeModule } from '../../../../pipes/format/capitalize.module';
import { MatChipsModule } from '@angular/material/chips';
import { NgIf, NgStyle } from '@angular/common';

@Component({
    selector: 'app-status-chip',
    templateUrl: './status-chip.component.html',
    styleUrls: ['./status-chip.component.scss'],
    standalone: true,
    host: { class: 'status-chip' },
    imports: [
        AnimatedDirective,
        CapitalizePipeModule,
        MatChipsModule,
        NgIf,
        NgStyle,
    ],
})
export class AppStatusChipComponent<T> implements OnChanges {
    @Input() statusId: number;
    @Input() statuses: T[];
    @Input() label: string;
    @Input() loadingInitialData = false;

    @Output() statusSelected: EventEmitter<number> = new EventEmitter<number>();

    chip: T;

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            this.refreshChip();
        }
    }

    private refreshChip() {
        this.chip = this.statuses?.find((status) => {
            if (status.hasOwnProperty('id')) {
                return status['id'] === this.statusId;
            }

            return;
        });
    }
}
